import classNames from "classnames/bind";
import React from "react";
import { Button } from "../Button";
import styles from "./Drawer.module.scss";
import { DrawerNextPrevButtonsProps } from "./types";
const cx = classNames.bind(styles);

const DrawerNextPrevButtons = ({
  onNextClick,
  isNextDisabled,
  onPrevClick,
  isPrevDisabled,
}: DrawerNextPrevButtonsProps) => {
  return (
    <div className={cx("nextPrevButtonsContainer")}>
      <Button
        icon="caret-up"
        iconProps={{
          size: 24,
        }}
        size="small"
        className={cx("nextPrevButton")}
        disabled={isNextDisabled}
        onClick={() => {
          onNextClick?.();
        }}
      />
      <Button
        icon="caret-down"
        iconProps={{
          size: 24,
        }}
        size="small"
        disabled={isPrevDisabled}
        className={cx("nextPrevButton")}
        onClick={() => {
          onPrevClick?.();
        }}
      />
    </div>
  );
};

export default DrawerNextPrevButtons;
